import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { getLanguage, subscribe } from "../language/LanguageSetting.js";
import logo from "../images/logo.min.svg";
import logodark from "../images/darkthemelogo.svg";
//import skyledQR  from '../images/skyledQR.svg'

const Footer = () => {
  const [isFinnish, setIsFinnish] = useState(getLanguage());

  useEffect(() => {
    const unsubscribe = subscribe(() => {
      setIsFinnish(getLanguage());
    });

    return () => unsubscribe();
  }, []);

  const texts = isFinnish
    ? {
        yhteisöille: "Yhteisöille",
        mainostajille: "Mainostajille",
        asiakaspalvelu: "Asiakaspalvelu",
        myynti: "Myynti",
        puh: "puh",
        opastamassa: "Opastamassa",
      }
    : {
        yhteisöille: "For communities",
        mainostajille: "For marketers",
        asiakaspalvelu: "Customer service",
        myynti: "Sales",
        puh: "tel",
        opastamassa: " ",
      };

  return (
    <footer className="sh-custom-light relative z-50 bg-grey-light dark:bg-darker">
      <div className="grid px-6 pb-4 pt-8 md:auto-rows-min md:grid-cols-2">
        <div className="mb-4 flex flex-col md:mb-10 md:items-start">
          <img
            src={logo}
            alt="Opasti logo"
            className="mb-6 block h-8 dark:hidden md:h-10"
          />
          <img
            src={logodark}
            alt="Opasti logo"
            className="mb-6 hidden h-8 dark:block md:h-10"
          />
          <ul className="menu">
            <li>
              <Link title="Lisätietoja" to="/app/housing-coops">
                {texts.yhteisöille}
              </Link>
            </li>
            <li>
              <Link title="Lisätietoja" to="/app/marketers">
                {texts.mainostajille}
              </Link>
            </li>
          </ul>
        </div>
        <div className="mb-4 flex flex-col justify-center gap-2 text-center md:flex-row md:justify-end md:gap-8 md:text-left">
          <div>
            <p className="dark:text-white">{texts.asiakaspalvelu}</p>
            <p className="text-sm dark:text-white">asiakaspalvelu@skyled.fi</p>
          </div>
          <div>
            <p className="dark:text-white">{texts.myynti}</p>
            <p className="text-sm dark:text-white">myynti@skyled.fi</p>
            <p className="text-sm dark:text-white">{texts.puh}. 010-338 4441</p>
          </div>
        </div>
        <div className="text-center dark:text-white md:text-left">
          <p>
            {texts.opastamassa}{" "}
            <a
              title="www.skyled.fi"
              href="https://www.skyled.fi"
              className="link-style"
              style={{ color: "#6495ED" }}
            >
              SkyLED Finland Oy
            </a>
          </p>
          <p className="text-sm">&copy; Opasti</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
